import { render } from "./OwnerPlantListView.vue?vue&type=template&id=27cf3be7&ts=true"
import script from "./OwnerPlantListView.vue?vue&type=script&lang=ts"
export * from "./OwnerPlantListView.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src2602801780/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__